var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/**
 * @copyright
 * Copyright(c) 2019 SICK AG
 */

/* eslint-disable jsdoc/require-returns */
import { Component, svg, Prop, Watch } from '@sick-davinci/ce-decorators';
import { live } from 'lit-html/directives/live.js';
import { ColoredDataElement } from '../_utils/ColoredDataElement.js'; // should be imported first, so css variables from theme-base are available

import { SvgTools } from '../_utils/SvgTools.js';
import { NumberFormatter, defaultShorthandLabels } from '../_utils/NumberFormatter.js';
import { toCssColorValue } from '../_utils/ColorTools.js';
import { ThemeService } from '../_utils/ThemeService.js';
/**
 * Stroke
 */

class Stroke {
  constructor() {
    this.color = 'black';
    this.width = 1.0;
    this.lineCap = 'round';
  }

}
/**
 * helper for calculate the right sizes of the donut sections
 */


// size of the svg
const SVG = {
  wLabels: {
    Width: 320,
    Height: 280
  },
  woLabels: {
    Width: 256,
    Height: 256
  }
};
/**
 * Parent of all donuts.
 */

export let AbstractDonut = (_dec = Component({
  abstract: true
}), _dec2 = Reflect.metadata("design:paramtypes", [Boolean]), _dec3 = Prop(), _dec4 = Reflect.metadata("design:type", Object), _dec5 = Prop(), _dec6 = Reflect.metadata("design:type", Object), _dec7 = Prop(), _dec8 = Reflect.metadata("design:type", String), _dec9 = Prop(), _dec10 = Reflect.metadata("design:type", Boolean), _dec11 = Prop(), _dec12 = Reflect.metadata("design:type", Object), _dec13 = Watch('palette'), _dec14 = Reflect.metadata("design:paramtypes", []), _dec15 = Watch('shorthandLabels'), _dec16 = Reflect.metadata("design:paramtypes", []), _dec(_class = _dec2(_class = (_class2 = class AbstractDonut extends ColoredDataElement {
  /**
   * Values to show as parts of the donut.
   * The large the value the larger the part (arc).
   * All values are normalized to the sum of all values.
   * Drawing starts at the top and continues in clock-wise-direction.
   * Each array element is colored accordings to the defined *palette* attribute.
   */

  /**
   * List of all legend-labels. if not set, no legend is displayed.
   */

  /**
   * The displayed unit string appended to each value-label.
   * Only has effect if labels is set.
   */

  /**
   * use abbreviations for big numbers for value-labels (e.g. k=kilo=1000, m=milli=1/1000, etc.)
   *
   * @default defaultShorthandLabels
   */

  /**
   * The colors to be used for the segments of the donut.
   * The first element denotes the color for the first segment, the second element denotes the color for the second segment so on.
   * Each entry of this array is either interpreted as an index referring to the selected palette, or a css-color-value designation (e.g. 'purple', '#ff00ff', 'rgba(255,255,128,0.5)')
   *
   * If there are more segments than colors the array will be traversed from the beginning
   *
   * @default all colors of the current color-palette
   */
  get colors() {
    return this._getSeriesColors();
  }

  set colors(value) {
    this._setSeriesColors(value);

    this._computeSegmentColors();
  }

  paletteWatcher() {
    this._computeSegmentColors();

    this.scheduleRender(true);
  }

  shorthandLabelsWatcher() {
    this._labelFormatter = new NumberFormatter(this.shorthandLabels);
  }
  /**
   * The standard size of the gaps between the arcs.
   * Could be smaller to arrange multiple arcs on less space.
   */


  /**
   * ctor
   *
   * @param _showLabels - display labels beside value arcs
   */
  constructor(_showLabels) {
    super();
    this._labelFormatter = NumberFormatter.CREATE_DEFAULT();
    this._segmentLabels = [];

    _initializerDefineProperty(this, "values", _descriptor, this);

    _initializerDefineProperty(this, "legendLabels", _descriptor2, this);

    _initializerDefineProperty(this, "unit", _descriptor3, this);

    _initializerDefineProperty(this, "shorthandLabels", _descriptor4, this);

    this.gap = 2.75;

    this._getTextAnchor = xPos => {
      if (xPos < -10) {
        return 'end';
      } else if (xPos > 10) {
        return 'start';
      } else {
        return 'mid';
      }
    };

    this._showLabels = _showLabels;
    this._labelFormatter = new NumberFormatter(this.shorthandLabels);

    this._computeSegmentColors();
  }

  componentConnected() {
    super.componentConnected();
    ThemeService.GET_INSTANCE().addListener(() => this.paletteWatcher());
  }

  _createArc(c, r, sd, ed, stroke) {
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('stroke', stroke.color);
    path.setAttribute('stroke-width', '' + stroke.width);
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke-linecap', stroke.lineCap);
    path.setAttribute('d', SvgTools.DESCRIBE_ARC(c.x, c.y, r, sd, ed));
    return path;
  }

  _createLabel(c, r, sd, ed, valLabel, segLabel, color) {
    const txt = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    txt.textContent = valLabel;
    const pos = SvgTools.POLAR_TO_CARTESIAN(c.x, c.y, r * 1.15, (sd + ed) / 2);

    if (pos.x < c.x) {
      txt.textContent = segLabel + ' ' + txt.textContent;
    } else {
      txt.textContent += ' ' + segLabel;
    }

    txt.setAttribute('transform', `translate(${pos.x} ${pos.y})`);
    txt.setAttribute('stroke', color);
    txt.setAttribute('fill', color);
    txt.setAttribute('text-anchor', this._getTextAnchor(pos.x - c.x));
    txt.setAttribute('alignment-baseline', 'central');
    txt.classList.add('label');
    return txt;
  }

  _createSect(sect, val, idx) {
    const center = {
      x: SVG.woLabels.Width / 2,
      y: SVG.woLabels.Height / 2
    };
    const r = center.y * .94;
    const curr = sect.sum !== 0 ? val / sect.sum : 0;
    const stroke = {
      color: this._segmentColors[idx % this._segmentColors.length].replace('#0x', '#'),
      width: 7,
      lineCap: 'butt'
    };
    sect.end = sect.start + curr;
    let sd = sect.start * 360 + this.gap;
    let ed = sect.end * 360 - this.gap;

    if (ed - sd <= 0) {
      // to small to draw: draw just a small section
      sd = sect.start * 360 + this.gap * .8;
      ed = sect.start * 360 + this.gap * 1.2;
    }

    sect.start = sect.end;
    const valLabel = this._labelFormatter.format(val) + this.unit; // max. 2 decimal places with shorthands

    const g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    g.appendChild(this._createArc(center, r, sd, ed, stroke));

    if (this._showLabels) {
      g.appendChild(this._createLabel(center, r, sd, ed, valLabel, this._segmentLabels[idx] || '', stroke.color));
    }

    return g;
  }

  _createSections() {
    const sum = this.values.reduce((x, y) => x + Math.abs(y), 0);
    const sect = {
      sum,
      start: 0,
      end: 0
    };
    return this.values.map((iVal, idx) => this._createSect(sect, Math.abs(iVal), idx));
  }

  _createSVG() {
    const w = SVG.woLabels.Width;
    const h = SVG.woLabels.Height;
    const r = SVG.woLabels.Width * 0.38; // since transform is also set from outside, we need to make in volatile (live) in order to be updated propertly

    return svg`<svg viewBox="0 0 ${w} ${h}" xmlns="http://www.w3.org/2000/svg">
      <g transform-origin="center" transform="${live('scale(1)')}">
        ${this._createSections()}
        <circle cx="${w / 2}" cy="${h / 2}" r="${r}" stroke-width="18" fill="none" />
      </g>
    </svg>`;
  }
  /**
   * Computes the segment colors from the css styles for the segment-style elements.
   */


  _computeSegmentColors() {
    this._segmentColors = this.colors.map(color => toCssColorValue(color, this.palette));
  } // make sure the text does not overwrite the chart itself: go from left to right if on the right side of the chart and vice versa


}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "values", [_dec3, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "legendLabels", [_dec5, _dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "unit", [_dec7, _dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "shorthandLabels", [_dec9, _dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return defaultShorthandLabels;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "colors", [_dec11, _dec12], Object.getOwnPropertyDescriptor(_class2.prototype, "colors"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "paletteWatcher", [_dec13, _dec14], Object.getOwnPropertyDescriptor(_class2.prototype, "paletteWatcher"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "shorthandLabelsWatcher", [_dec15, _dec16], Object.getOwnPropertyDescriptor(_class2.prototype, "shorthandLabelsWatcher"), _class2.prototype)), _class2)) || _class) || _class);
